// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2MJnS","header":"PatientQuestionnaire_header__2DWhP","info":"PatientQuestionnaire_info__2f2Ra"};